// TODO also need to update src/components/common/AttackTypeIcon.js for FA icons (or more appropriately, make it use this instead)
import { keyframes } from '@emotion/react'
import {
  faAws,
  faMicrosoft,
  faNodeJs,
  faGolang,
  faPython,
  faJava
} from '@fortawesome/free-brands-svg-icons'
import {
  faArrowDown,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faArrowRotateLeft,
  faBell,
  faBolt,
  faBookOpen,
  faBooks,
  faBuilding,
  faCalendar,
  faChartLineUp,
  faChartNetwork,
  faChartPieSimple,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleQuestion,
  faCircleTrash,
  faCircleUser,
  faClipboardList,
  faClockRotateLeft,
  faClone,
  faClose,
  faCode,
  faCompress,
  faCopy,
  faCube,
  faCubes,
  faDharmachakra,
  faEdit,
  faExpand,
  faEye,
  faEyeSlash,
  faFaceThermometer,
  faFireExtinguisher,
  faFlag,
  faFlask,
  faFlaskVial,
  faGear,
  faGearCode,
  faGears,
  faGraduationCap,
  faHouse,
  faJoystick,
  faKey,
  faLayerGroup,
  faLock,
  faMagnifyingGlass,
  faMessageQuestion,
  faMinus,
  faPencil,
  faPlus,
  faPowerOff,
  faQuestion,
  faRectangleHistory,
  faSliders,
  faSplit,
  faTrash,
  faWarning,
  faXmark,
  faWavePulse,
  faWrench
} from '@fortawesome/pro-light-svg-icons'
import {
  faArrowsRotate as faRegularArrowsRotate,
  faCalendar as faRegularCalendar,
  faGear as faRegularGear,
  faHourglassStart as faRegularHourglassStart,
  faLightbulbExclamationOn as faRegularLightbulbExclamationOn,
  faStopwatch as faRegularStopwatch,
  faTelescope as faRegularTelescope,
  // --- Fault Icons
  faArrowUpArrowDown as faRegularArrowUpArrowDown, // IO
  faCompactDisc as faRegularCompactDisc, // disk
  faEarthAmericas as faRegularEarthAmericas, // zone
  faFaceExhaling as faRegularFaceExhaling, // process_exhaustion
  faFillDrip as faRegularFillDrip, // packet_loss
  faFileCertificate as faRegularFileCertificate, // certificate_expiry
  faGlobe as faRegularGlobe, // DNS
  faServer as faRegularServer, // host
  faSkull as faRegularSkull, // process_killer
  faContainerStorage as faContainerStorage
} from '@fortawesome/pro-regular-svg-icons'
import {
  faAngleLeft as faSolidAngleLeft,
  faAngleRight as faSolidAngleRight,
  faAnglesLeft as faSolidAnglesLeft,
  faAnglesRight as faSolidAnglesRight,
  faArrowAltDown as faSolidArrowAltDown,
  faArrowAltUp as faSolidArrowAltUp,
  faArrowDown as faSolidArrowDown,
  faArrowRight as faSolidArrowRight,
  faArrowTrendDown as faSolidArrowTrendDown,
  faArrowTrendUp as faSolidArrowTrendUp,
  faArrowUp as faSolidArrowUp,
  faArrowUpRightFromSquare as faSolidArrowUpRightFromSquare,
  faArrowsRotate as faSolidArrowsRotate,
  faArrowsTurnRight as faSolidArrowsTurnRight,
  faBuilding as faSolidBuilding,
  faCaretCircleRight as faSolidCaretCircleRight,
  faCaretDown as faSolidCaretDown,
  faCaretLeft as faSolidCaretLeft,
  faCaretRight as faSolidCaretRight,
  faCaretUp as faSolidCaretUp,
  faCheck as faSolidCheck,
  faCircle as faSolidCircle,
  faCircleCheck as faSolidCircleCheck,
  faCircleInfo as faSolidCircleInfo,
  faCircleMinus as faSolidCircleMinus,
  faCircleXmark as faSolidCircleXmark,
  faCirclesOverlap as faSolidCirclesOverlap,
  faClose as faSolidClose,
  faCreditCard as faSolidCreditCard,
  faDash as faSolidDash,
  faDiagramProject as faSolidDiagramProject,
  faDiamondExclamation as faSolidDiamondExclamation,
  faDownload as faSolidDownload,
  faEllipsis as faSolidEllipsis,
  faEllipsisVertical as faSolidEllipsisVertical, // kebab - just in case anyone's searching for that term
  faExclamation as faSolidExclamation,
  faExclamationTriangle as faSolidExclamationTriangle,
  faFaceExhaling as faSolidFaceExhaling,
  faFilter as faSolidFilter,
  faFlag as faSolidFlag,
  faFlagCheckered as faSolidFlagCheckered,
  faFlask as faSolidFlask,
  faFloppyDisk as faSolidFloppyDisk,
  faGrid as faSolidGrid,
  faHorizontalRule as faSolidHorizontalRule,
  faLink as faSolidLink,
  faMinus as faSolidMinus,
  faPlay as faSolidPlay,
  faPlus as faSolidPlus,
  faRectangleHistory as faSolidRectangleHistory,
  faShield as faSolidShield,
  faSparkles as faSolidSparkles,
  faTrophy as faSolidTrophy,
  faUser as faSolidUser,
  faUserGroup as faSolidUserGroup,
  faWarning as faSolidWarning,
  faTowerBroadcast as faSolidTowerBroadcast,
  faXmark as faSolidXmark,
  // --- Fault Icons
  faClockRotateLeft as faSolidClockRotateLeft, // time_travel
  faGalaxy as faSolidGalaxy, // blackhole / failure
  faListTimeline as faSolidListTimeline, // scenario
  faMemory as faSolidMemory, // memory
  faMicrochip as faSolidMicrochip, // cpu
  faMicrochipAi as faSolidMicrochipAi, // gpu
  faPowerOff as faSolidPowerOff, // shutdown
  faTurtle as faSolidTurtle // latency
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'

import old_blackhole from 'assets/icons/args/blackhole-icon.svg?component'
import blockCount from 'assets/icons/args/block-count-icon.svg?component'
import BlockSize from 'assets/icons/args/block-size-icon.svg?component'
import cores from 'assets/icons/args/cores-icon.svg?component'
import corrupt from 'assets/icons/args/corrupt-icon.svg?component'
import cpu from 'assets/icons/args/cpu-icon.svg?component'
import delay from 'assets/icons/args/delay-icon.svg?component'
import device from 'assets/icons/args/device-icon.svg?component'
import dir from 'assets/icons/args/dir-icon.svg?component'
import disk from 'assets/icons/args/disk-icon.svg?component'
import dns from 'assets/icons/args/dns-icon.svg?component'
import fullMatch from 'assets/icons/args/full-match-icon.svg?component'
import gigabytes from 'assets/icons/args/gigabytes-icon.svg?component'
import host from 'assets/icons/args/host-icon.svg?component'
import io from 'assets/icons/args/io-icon.svg?component'
import ipaddress from 'assets/icons/args/ipaddress-icon.svg?component'
import killChildren from 'assets/icons/args/kill-children-icon.svg?component'
import latency from 'assets/icons/args/latency-icon.svg?component'
import length from 'assets/icons/args/length-icon.svg?component'
import MB from 'assets/icons/args/megabytes-icon.svg?component'
import memory from 'assets/icons/args/memory-icon.svg?component'
import mode from 'assets/icons/args/mode-icon.svg?component'
import monitor from 'assets/icons/args/monitor-icon.svg?component'
import newest from 'assets/icons/args/newest-icon.svg?component'
import ntp from 'assets/icons/args/ntp-icon.svg?component'
import offset from 'assets/icons/args/offset-icon.svg?component'
import oldest from 'assets/icons/args/oldest-icon.svg?component'
import packetLoss from 'assets/icons/args/packet_loss-icon.svg?component'
import percent from 'assets/icons/args/percent-icon.svg?component'
import port from 'assets/icons/args/port-icon.svg?component'
import processKiller from 'assets/icons/args/process-icon.svg?component'
import protocol from 'assets/icons/args/protocol-icon.svg?component'
import reboot from 'assets/icons/args/reboot-icon.svg?component'
import shutdown from 'assets/icons/args/shutdown-icon.svg?component'
import statusCheck from 'assets/icons/args/status_check-icon.svg?component'
import timeTravel from 'assets/icons/args/time_travel-icon.svg?component'
import workers from 'assets/icons/args/workers-icon.svg?component'
import old_checklist from 'assets/icons/checklist.svg?component'
import closeOctagonOutlineIcon from 'assets/icons/close-octagon-outline.svg?component'
import old_cube from 'assets/icons/cube.svg?component'
import old_navExperiment from 'assets/icons/experiments-nav.svg?component'
import old_services from 'assets/icons/services.svg?component'
import old_stack from 'assets/icons/stack.svg?component'
import targetIcon from 'assets/icons/targets.svg?component'
import old_trafficLight from 'assets/icons/traffic-light.svg?component'
import old_add from 'assets/iconsNew/add.svg?component'
import old_api from 'assets/iconsNew/api.svg?component'
import old_arrowDownOutline from 'assets/iconsNew/arrow-down-outline.svg?component'
import old_arrowUpOutline from 'assets/iconsNew/arrow-up-outline.svg?component'
import old_attacksIcon from 'assets/iconsNew/attacks.svg?component'
import old_caretBack from 'assets/iconsNew/caret-back.svg?component'
import old_caretDown from 'assets/iconsNew/caret-down.svg?component'
import old_caretForwardCircle from 'assets/iconsNew/caret-forward-circle.svg?component'
import old_caretForward from 'assets/iconsNew/caret-forward.svg?component'
import caretNeutral from 'assets/iconsNew/caret-neutral.svg?component' // TODO need to find replacement for this
import old_caretUp from 'assets/iconsNew/caret-up.svg?component'
import old_checkmarkDouble from 'assets/iconsNew/checkmark-double.svg?component'
import old_checkmark from 'assets/iconsNew/checkmark.svg?component'
import old_chevronBack from 'assets/iconsNew/chevron-back.svg?component'
import old_chevronDown from 'assets/iconsNew/chevron-down.svg?component'
import old_chevronForward from 'assets/iconsNew/chevron-forward.svg?component'
import old_chevronUp from 'assets/iconsNew/chevron-up.svg?component'
import clients from 'assets/iconsNew/clients.svg?component' // TODO find replacement
import old_close from 'assets/iconsNew/close.svg?component'
import old_cog from 'assets/iconsNew/cog.svg?component'
import old_company from 'assets/iconsNew/company.svg?component'
import old_copy from 'assets/iconsNew/copy.svg?component'
import old_docs from 'assets/iconsNew/docs.svg?component'
import old_edit from 'assets/iconsNew/edit.svg?component'
import old_ellipsisHorizontal from 'assets/iconsNew/ellipsis-horizontal.svg?component'
import old_ellipsisVertical from 'assets/iconsNew/ellipsis-vertical.svg?component'
import old_eyeOff from 'assets/iconsNew/eye-off.svg?component'
import old_eye from 'assets/iconsNew/eye.svg?component'
import old_grid from 'assets/iconsNew/grid.svg?component'
import helm from 'assets/iconsNew/helm.svg?component' // TODO no clear replacement - maybe dharmachakra? but that has more spokes - this is k8s specific
import old_info from 'assets/iconsNew/info.svg?component'
import old_key from 'assets/iconsNew/key.svg?component'
import old_lock from 'assets/iconsNew/lock.svg?component'
import old_move from 'assets/iconsNew/move.svg?component'
import old_power from 'assets/iconsNew/power.svg?component'
import old_remove from 'assets/iconsNew/remove.svg?component'
import old_report from 'assets/iconsNew/report.svg?component'
import old_scenarios from 'assets/iconsNew/scenarios.svg?component'
import old_schedulesIcon from 'assets/iconsNew/schedule.svg?component'
import search from 'assets/iconsNew/search.svg?component'
import share from 'assets/iconsNew/share.svg?component'
import starOutline from 'assets/iconsNew/star-outline.svg?component'
import star from 'assets/iconsNew/star.svg?component'
import support from 'assets/iconsNew/support.svg?component'
import trendingDown from 'assets/iconsNew/trending-down.svg?component'
import trendingUp from 'assets/iconsNew/trending-up.svg?component'
import unlock from 'assets/iconsNew/unlock.svg?component'
import user from 'assets/iconsNew/user.svg?component'
import users from 'assets/iconsNew/users.svg?component'
import warning from 'assets/iconsNew/warning.svg?component'
import mascotReversedIcon from 'assets/images/gremlin-mascot-reversed.svg?component'
import gremlinHeadLogo from 'assets/images/gremlin-mascot.svg?component'
import gremlinLogoPrimary from 'assets/logos/gremlin-logo-primary.svg?component'
import gremlinLogoWhite from 'assets/logos/gremlin-logo-white.svg?component'
import statusCheckGremlinIcon from 'assets/status-check-gremlin.svg?component'

const oldIcons = {
  old_navExperiment,
  old_blackhole,
  old_checklist,
  old_cube,
  old_services,
  old_stack,
  old_trafficLight,
  old_add,
  old_api,
  old_arrowDownOutline,
  old_arrowUpOutline,
  old_attacksIcon,
  old_caretBack,
  old_caretDown,
  old_caretForwardCircle,
  old_caretForward,
  old_caretUp,
  old_checkmarkDouble,
  old_checkmark,
  old_chevronBack,
  old_chevronDown,
  old_chevronForward,
  old_chevronUp,
  old_close,
  old_cog,
  old_company,
  old_copy,
  old_docs,
  old_edit,
  old_ellipsisHorizontal,
  old_ellipsisVertical,
  old_eyeOff,
  old_eye,
  old_grid,
  old_info,
  old_key,
  old_lock,
  old_move,
  old_power,
  old_remove,
  old_report,
  old_scenarios,
  old_schedulesIcon
}

const attacks = {
  cpu,
  disk,
  dns,
  io,
  latency,
  memory,
  packetLoss,
  process_killer: processKiller,
  shutdown,
  time_travel: timeTravel
}

const args = {
  // api,
  'all-cores': cores,
  'block-count': blockCount,
  'block-size': BlockSize,
  cores,
  corrupt,
  delay,
  device,
  dir,
  // docs,
  egressPorts: port,
  egress_port: port,
  exact: dir,
  'full-match': fullMatch,
  full: fullMatch,
  gigabytes,
  group: users,
  host,
  hostname: port,
  ingressPorts: port,
  ingress_port: port,
  interval: delay,
  ipaddress,
  ipprotocol: protocol,
  'kill-children': killChildren,
  kill_children: killChildren,
  length,
  megabytes: MB,
  MB,
  mode,
  monitor,
  ms: delay,
  newest,
  ntp,
  offset,
  oldest,
  packet_loss: packetLoss,
  percent,
  process: processKiller,
  protocol,
  reboot,
  'source-ports': port,
  src_port: port,
  port,
  workers,
  user,
  volumePercentage: percent
}

const faAttacks = {
  blackhole: faSolidGalaxy,
  gpu: faSolidMicrochipAi,
  collect_certs: faRegularFileCertificate,
  process_exhaustion: faSolidFaceExhaling
}

const faArgs = {
  api: faCode,
  'block-count': faLayerGroup,
  'block-size': faCube,
  docs: faBookOpen
}

const icons = {
  ...attacks,
  ...args,
  ...oldIcons,
  caretNeutral,
  clients,
  closeOctagonOutlineIcon,
  gremlinHeadLogo,
  gremlinLogoPrimary,
  gremlinLogoWhite,
  helm,
  trendingDown,
  trendingUp,
  mascotReversedIcon,
  search,
  share,
  star,
  starOutline,
  status_check: statusCheck,
  statusCheckGremlinIcon,
  support,
  targetIcon,
  unlock,
  users,
  warning
}

export type FontAwesomeIconName = keyof typeof fontAwesomeIcons | 'clients'
export type LegacyIconName = keyof typeof icons
export type IconName = FontAwesomeIconName | LegacyIconName

export type IconProps = {
  icon: IconName
  className?: string
  spinning?: boolean
} & React.HTMLAttributes<HTMLElement>

// list any solid icons here and prefix their name with "solid"
// to make it obvious in the code that it's intended to be a solid icon and not the standard light version
const solidFontAwesomeIcons = {
  solidAngleLeft: faSolidAngleLeft,
  solidAngleRight: faSolidAngleRight,
  solidAnglesLeft: faSolidAnglesLeft,
  solidAnglesRight: faSolidAnglesRight,
  solidArrowAltDown: faSolidArrowAltDown,
  solidArrowAltUp: faSolidArrowAltUp,
  solidArrowDown: faSolidArrowDown,
  solidArrowRight: faSolidArrowRight,
  solidArrowTrendDown: faSolidArrowTrendDown,
  solidArrowTrendUp: faSolidArrowTrendUp,
  solidArrowUp: faSolidArrowUp,
  solidArrowsRotate: faSolidArrowsRotate,
  solidArrowsTurnRight: faSolidArrowsTurnRight,
  solidBuilding: faSolidBuilding,
  solidCaretCircleRight: faSolidCaretCircleRight,
  solidCaretDown: faSolidCaretDown,
  solidCaretLeft: faSolidCaretLeft,
  solidCaretRight: faSolidCaretRight,
  solidCaretUp: faSolidCaretUp,
  solidCheck: faSolidCheck,
  solidCircle: faSolidCircle,
  solidCircleCheck: faSolidCircleCheck,
  solidCircleInfo: faSolidCircleInfo,
  solidCircleMinus: faSolidCircleMinus,
  solidCircleXmark: faSolidCircleXmark,
  solidCirclesOverlap: faSolidCirclesOverlap,
  solidClose: faSolidClose,
  solidCreditCard: faSolidCreditCard,
  solidDash: faSolidDash,
  solidDiagramProject: faSolidDiagramProject,
  solidDiamondExclamation: faSolidDiamondExclamation,
  solidDownload: faSolidDownload,
  solidEllipsis: faSolidEllipsis,
  solidEllipsisVertical: faSolidEllipsisVertical,
  solidExclamation: faSolidExclamation,
  solidExclamationTriangle: faSolidExclamationTriangle,
  solidFilter: faSolidFilter,
  solidFlag: faSolidFlag,
  solidFlagCheckered: faSolidFlagCheckered,
  solidFlask: faSolidFlask,
  solidFloppyDisk: faSolidFloppyDisk,
  solidGrid: faSolidGrid,
  solidHorizontalRule: faSolidHorizontalRule,
  solidLink: faSolidLink,
  solidMinus: faSolidMinus,
  solidPlay: faSolidPlay,
  solidPlus: faSolidPlus,
  solidRectangleHistory: faSolidRectangleHistory,
  solidShield: faSolidShield,
  solidSparkles: faSolidSparkles,
  solidTrophy: faSolidTrophy,
  solidUser: faSolidUser,
  solidUserGroup: faSolidUserGroup,
  solidWarning: faSolidWarning,
  solidTowerBroadcast: faSolidTowerBroadcast,
  solidXmark: faSolidXmark,
  // --- Fault Icons
  solidClockRotateLeft: faSolidClockRotateLeft, // time_travel
  solidGalaxy: faSolidGalaxy, // blackhole / failure
  solidListTimeline: faSolidListTimeline, // scenario
  solidMemory: faSolidMemory, // memory
  solidMicrochip: faSolidMicrochip, // cpu
  solidMicrochipAi: faSolidMicrochipAi, // gpu
  solidPowerOff: faSolidPowerOff, // shutdown
  solidTurtle: faSolidTurtle // latency
}

const regularFontAwesomeIcons = {
  regularArrowsRotate: faRegularArrowsRotate,
  regularCalendar: faRegularCalendar,
  regularGear: faRegularGear,
  regularHourglass: faRegularHourglassStart,
  regularLightbulbExclamationOn: faRegularLightbulbExclamationOn,
  regularStopwatch: faRegularStopwatch,
  regularTelescope: faRegularTelescope,
  // --- Fault Icons
  regularArrowUpArrowDown: faRegularArrowUpArrowDown, // IO
  regularCompactDisc: faRegularCompactDisc, // disk
  regularEarthAmericas: faRegularEarthAmericas, // zone
  regularFaceExhaling: faRegularFaceExhaling, // process_exhaustion
  regularFileCertificate: faRegularFileCertificate, // certificate_expiry
  regularFillDrip: faRegularFillDrip, // packet_loss
  regularGlobe: faRegularGlobe, // DNS
  regularServer: faRegularServer, // host
  regularSkull: faRegularSkull // process_killer
}

const brandFontAwesomeIcons = {
  awsIcon: faAws,
  microsoftIcon: faMicrosoft,
  nodeJsIcon: faNodeJs,
  golangIcon: faGolang,
  pythonIcon: faPython,
  javaIcon: faJava
}

const fontAwesomeIcons = {
  ...faAttacks,
  ...faArgs,
  ...regularFontAwesomeIcons,
  ...solidFontAwesomeIcons,
  ...brandFontAwesomeIcons,
  arrowDown: faArrowDown,
  arrowLeft: faArrowLeft,
  arrowRight: faArrowRight,
  arrowRotateLeft: faArrowRotateLeft,
  arrowUp: faArrowUp,
  arrowUpRightFromSquare: faSolidArrowUpRightFromSquare, // TODO
  arrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  bell: faBell,
  bolt: faBolt,
  bookOpen: faBookOpen,
  books: faBooks,
  building: faBuilding,
  calendar: faCalendar,
  chartLineUp: faChartLineUp,
  chartNetwork: faChartNetwork, // service - just in case anyone's searching for that term
  chartPieSimple: faChartPieSimple,
  checkDouble: faCheckDouble,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  chevronUp: faChevronUp,
  circleCheck: faCircleCheck,
  circleQuestion: faCircleQuestion,
  circleTrash: faCircleTrash,
  circleUser: faCircleUser,
  clipboardList: faClipboardList,
  clockRotateLeft: faClockRotateLeft,
  clone: faClone,
  close: faClose,
  code: faCode,
  compress: faCompress,
  containerStorage: faContainerStorage,
  copy: faCopy,
  cube: faCube,
  cubes: faCubes,
  dharmachakra: faDharmachakra,
  edit: faEdit,
  expand: faExpand,
  eye: faEye,
  eyeSlash: faEyeSlash,
  faceThermometer: faFaceThermometer,
  fireExtinguisher: faFireExtinguisher,
  flag: faFlag,
  flask: faFlask,
  flaskVial: faFlaskVial,
  gear: faGear,
  gearCode: faGearCode,
  gears: faGears,
  graduationCap: faGraduationCap,
  hourglass: faRegularHourglassStart,
  house: faHouse,
  joystick: faJoystick,
  key: faKey,
  layerGroup: faLayerGroup,
  lock: faLock,
  magnifyingGlass: faMagnifyingGlass,
  messageQuestion: faMessageQuestion,
  minus: faMinus,
  pencil: faPencil,
  plus: faPlus,
  powerOff: faPowerOff,
  question: faQuestion,
  rectangleHistory: faRectangleHistory,
  sliders: faSliders,
  split: faSplit,
  trash: faTrash,
  warning: faWarning,
  wavePulse: faWavePulse,
  wrench: faWrench,
  xmark: faXmark
}

const spin = keyframes`
  0% {
    transform: rotate(0turn)
  }
  100% {
    transform: rotate(1turn)
  }
`

const Icon = React.forwardRef<React.Ref<any>, IconProps>(
  ({ icon, className, spinning = false, ...rest }, ref) => {
    if (!fontAwesomeIcons[icon]) {
      const IconComponent = icons[icon] ?? old_navExperiment

      return (
        <IconComponent
          ref={ref}
          className={clsx('Icon', className)}
          css={[
            { shapeRendering: 'geometricPrecision' },
            spinning ? { animation: `${spin} 2s linear infinite` } : null
          ]}
          data-test-icon={icon}
          {...rest}
        />
      )
    }

    return (
      // @ts-ignore the types for this 3rd party component are bonkers
      <FontAwesomeIcon
        // @ts-ignore third party screwiness
        ref={ref}
        className={clsx('Icon', className)}
        css={[
          { shapeRendering: 'geometricPrecision' },
          spinning ? { animation: `${spin} 2s linear infinite` } : null
        ]}
        data-test-icon={icon}
        icon={fontAwesomeIcons[icon] || faFlask}
        {...rest}
      />
    )
  }
)

Icon.displayName = 'Icon'

export default Icon
